module.exports = __webpack_public_path__ + "img/plants01.9d583853.png";